import { useUserProfile } from 'app/components/user-profile/useUserProfile'
import { UserProfileComponent } from 'app/components/user-profile/UserProfileComponent'

export const handle = {
  title: `Profile`,
}

export default function UserProfile(): React.ReactElement {
  const hookData = useUserProfile()
  return <UserProfileComponent {...hookData} />
}
